import script from "./AnswerStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerStatus.vue?vue&type=script&setup=true&lang=js"

export default script